import { render, staticRenderFns } from "./messageDialog5.vue?vue&type=template&id=db162534&scoped=true&"
import script from "./messageDialog5.vue?vue&type=script&lang=js&"
export * from "./messageDialog5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db162534",
  null
  
)

export default component.exports